import { ICaseLawDocument } from "../model/CaseLawDocument";
import CaseLawDocumentMapper from "../service/CaseLawDocumentMapper";
import CaseLawDocumentParamMapper from "../service/CaseLawDocumentParamMapper";
import Constants from "../common/Constants";
import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";

export default class FindCaseLawDocumentInteractor {
  private resource: FindResourceEntryInteractor<ICaseLawDocument>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(
      Constants.endpointBasePath,
      CaseLawDocumentMapper,
      CaseLawDocumentParamMapper,
      caseLawDocumentId
    );
  }
}
